module.exports = __webpack_public_path__ + "img/addPlusIcon.23760c57.svg";